/// <amd-module name="TFS/Admin/OrganizationAadControls/Components/AadActionSuccessDialog" />
import React = require("react");
import AdminResources = require("TFS/Admin/OrganizationAadControls/Resources");
import { Dialog } from "VSSUI/Dialog";
import { format } from "VSS/Core/Util/String";
import { Link } from "VSSUI/Link";
import { createMarkup } from "TFS/Admin/Common/Util/HtmlString";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { filterXSS } from "xss";
import { VssComponent } from "VSS/Platform/Layout";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { IAadActionSuccessDialogComponentProps } from "TFS/Admin/OrganizationAadCommon/Contracts/DialogControls.props";

export class AadActionSuccessDialogComponent extends React.Component<IAadActionSuccessDialogComponentProps> {
    public render(): JSX.Element {
        return (
            <Dialog
                calloutContentClassName="action-success-dialog"
                footerButtonProps={[
                    {
                        primary: true,
                        onClick: this.props.onCloseAndSignout,
                        text: AdminResources.CloseAndSignOut
                    }
                ]}
                lightDismiss={false}
                onDismiss={this.props.onCloseAndSignout}
                titleProps={{ text: this._getDialogTitle() }}
            >
                {this._renderDialogBody()}
            </Dialog>
        );
    }

    private _getDialogTitle(): string {
        if (this.props.isConnectAction === true) {
            return AdminResources.AadConnectSuccessTitle;
        } else {
            return AdminResources.AadDisconnectSuccessTitle;
        }
    }

    private _renderDialogBody(): JSX.Element {
        if (this.props.isConnectAction === true) {
            if (this.props.countOfUnresolvedUsers == 0) {
                return (
                    <div className="block-display">
                        <p className="aad-action-success-dialog-paragraph">
                            <span
                                dangerouslySetInnerHTML={createMarkup(
                                    format(
                                        AdminResources.AadConnectSuccessDescription,
                                        filterXSS(this.props.orgName),
                                        this.props.orgTenantName ? filterXSS(this.props.orgTenantName) : ""
                                    )
                                )}
                            />
                        </p>
                        <p>{format(AdminResources.AadConnectSuccessSignOutInfo, filterXSS(this.props.orgName))}</p>
                    </div>
                );
            } else {
                return (
                    <div className="block-display">
                        {this._renderDisconnectUser()}
                        <p>
                            <span
                                dangerouslySetInnerHTML={createMarkup(
                                    format(
                                        AdminResources.AadConnectSuccessDescription,
                                        filterXSS(this.props.orgName),
                                        this.props.orgTenantName ? filterXSS(this.props.orgTenantName) : ""
                                    )
                                )}
                            />
                        </p>
                        <p>{format(AdminResources.AadConnectSuccessSignOutInfo, this.props.orgName)}</p>
                    </div>
                );
            }
        } else {
            return (
                <div>
                    <p>
                        <span
                            dangerouslySetInnerHTML={createMarkup(
                                format(
                                    AdminResources.AadDisconnectSuccessDescription,
                                    this.props.orgTenantName ? filterXSS(this.props.orgTenantName) : ""
                                )
                            )}
                        />
                    </p>
                    <p>{format(AdminResources.AadDisonnectSuccessSignOutInfo, this.props.orgName)}</p>
                </div>
            );
        }
    }

    private _renderDisconnectUser(): JSX.Element {
        return (
            <MessageBar severity={MessageBarSeverity.Warning}>
                <div className="block-display">
                    <FormatComponent format={AdminResources.AadConnectSuccessDescriptionSecond}>
                        {this.props.showTooManyUsersWarning !== true ? (
                            <span>
                                <Link className="cursor-pointer" onClick={() => this.props.onOpenDisconnectUserDialog()}>
                                    <span
                                        dangerouslySetInnerHTML={createMarkup(
                                            format(AdminResources.AadConnectSuccessLink, this.props.countOfUnresolvedUsers)
                                        )}
                                    />
                                </Link>
                            </span>
                        ) : (
                            <span>{AdminResources.AadConnectDialogSomeMembers}</span>
                        )}
                        <span
                            dangerouslySetInnerHTML={createMarkup(format(AdminResources.BoldedName, filterXSS(this.props.orgName)))}
                        />
                        <span
                            dangerouslySetInnerHTML={createMarkup(
                                format(
                                    AdminResources.BoldedName,
                                    this.props.orgTenantName ? filterXSS(this.props.orgTenantName) : ""
                                )
                            )}
                        />
                        <span>{this.props.orgTenantName ? filterXSS(this.props.orgTenantName) : ""}</span>
                        <span>{this.props.orgTenantName ? filterXSS(this.props.orgTenantName) : ""}</span>
                    </FormatComponent>
                </div>
            </MessageBar>
        );
    }
}

VssComponent.register("ms.vss-admin-web.aad-action-success-dialog", AadActionSuccessDialogComponent);
